import _Vue from 'vue'

export type I18nString = string | { zh: string, en: string }

/**
 * 根据locale，返回中文或英文字符串。
 */
export function $t2(str: I18nString, vue: Vue): string {
  if (typeof str === 'string') return str
  else return str[<keyof typeof str>vue.$i18n.locale]
}

/**
 * 总是返回英文字符串。用于链接等场合。
 * @param str
 */
export function $en(str: I18nString): string {
  if (typeof str === 'string') return str
  else return str["en"]
}

export function Plugin_i18nT2(Vue: typeof _Vue): void {
  Vue.prototype.$t2 = function (str: I18nString) {
    return $t2(str, this)
  }
  Vue.prototype.$en = function (str: I18nString) {
    return $en(str)
  }
}

declare module 'vue/types/vue' {
  interface Vue {
    $t2: typeof $t2;
    $en: typeof $en;
  }
}